import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';
import { PaymentPlanTableCell } from './ScheduleTypeCellParamTemplateDetailsStyles';
import { get, set } from '@totalsoft/change-tracking-react';

export const ScheduleTypeCellParamTemplateDetailsRowComponent = ({
  scheduleCellParamColumns,
  rowDataLens,
  rowIdx,
  isEditable
}) => {
  const rowData = rowDataLens |> get;

  return (
    <TableRow key={rowIdx + rowData.MonthNo}>
      {scheduleCellParamColumns?.map(m => {
        return (
          <PaymentPlanTableCell key={rowIdx + '_' + m.cellParamId}>
            <DynamicField
              id={'scheduleTypeCellParamTemplateSeasonalSettingsCard_' + rowIdx + '_' + m.cellParamName}
              controlType={m.controlType}
              inputProps={m.inputProps}
              isClearable={false}
              onChange={rowDataLens[m.cellParamName] |> set}
              disabled={m.readOnly || !isEditable}
              value={rowData[m.cellParamName]}
            />
          </PaymentPlanTableCell>
        );
      })}
    </TableRow>
  );
};

ScheduleTypeCellParamTemplateDetailsRowComponent.propTypes = {
  scheduleCellParamColumns: PropTypes.array.isRequired,
  rowDataLens: PropTypes.object.isRequired,
  rowIdx: PropTypes.number.isRequired,
  isEditable: PropTypes.bool,
};

export default ScheduleTypeCellParamTemplateDetailsRowComponent;
